// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"31d6cfe0","309":"9dbee736","621":"6e4dbdde","739":"6c2f8f97","987":"a37e3835"}[chunkId] + ".chunk.css";
};